export const allStoreIds = [1, 3, 11, 12, 13, 18, 19, 20, 21, 22, 23, 25, 26];



